import API from "./api"

const FavoriteService = {
  // Temple favorites
  getFavoriteTemples: async () => {
    try {
      const response = await API.get("/users/favorites/temples")
      return response.data
    } catch (error) {
      throw error
    }
  },

  addFavoriteTemple: async (templeId) => {
    try {
      const response = await API.post("/users/favorites/temples", { templeId })
      return response.data
    } catch (error) {
      throw error
    }
  },

  removeFavoriteTemple: async (templeId) => {
    try {
      const response = await API.delete(`/users/favorites/temples/${templeId}`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Pilgrimage favorites
  getFavoritePilgrimages: async () => {
    try {
      const response = await API.get("/users/favorites/pilgrimages")
      return response.data
    } catch (error) {
      throw error
    }
  },

  addFavoritePilgrimage: async (pilgrimageId) => {
    try {
      const response = await API.post("/users/favorites/pilgrimages", { pilgrimageId })
      return response.data
    } catch (error) {
      throw error
    }
  },

  removeFavoritePilgrimage: async (pilgrimageId) => {
    try {
      const response = await API.delete(`/users/favorites/pilgrimages/${pilgrimageId}`)
      return response.data
    } catch (error) {
      throw error
    }
  },
}

export default FavoriteService
